import React, { useState, Fragment, useEffect } from "react";
import Loading from "../assetLibComponents/Loading";
import { useDispatch, useSelector } from "react-redux";
import TabCalender from "../TabCalender";
import * as Icon from "react-bootstrap-icons";
import {
  googleCalenderAuth,
  getGoogleToken,
  getGoogleCalenderApiDetail,
  unlinkCalenderApi,
} from "../../redux/actions/settingActions";
import calendar from "../../assets/calendar.png";
import "../chatAiComponents/ChatAii.css";
import Unlink from "../../assets/unlink.svg";
import { useNavigate } from "react-router-dom";

const SettingCalender = (props) => {
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const [calendarData, setCalendarData] = useState("");
    const googleUrl = useSelector((state) => state.setting.fetchGoogleCalendarUrl);
    const isLoading = useSelector((state) => state.chatAi.loading);
    const [tabName, setTabName] = useState("Schedules");
    const tabs = [
        { name: "Connect", href: "/Setting/connect", current: true },
        { name: "Schedules", href: "/Setting/calender", current: false },
        { name: "Events", href: "/Setting/events", current: false },
    ];
    
    const authToken = props.authToken;
    
    useEffect(() => {
        dispatch(getGoogleCalenderApiDetail(authToken, onSuccess));    
        // if (!googleUrl?.length > 0) {
        //     dispatch(googleCalenderAuth(authToken, onSuccessAuth));
        // }
    }, [])
    
    const onSuccess = (value) => {
        setCalendarData(value);
    }
    
    const onSuccessAuth = (googleUrl) => {
        window.location.href = googleUrl;
    }
    
    useEffect(() => {
        // Get the current URL
        const currentURL = window.location.href;
        // Create a URL object to parse the URL
        const url = new URL(currentURL);
        // Get the "code" query parameter value
        const eCode = url.searchParams.get('code');
        if (eCode) {
            // Do something with the extracted "code" value
            console.log('Extracted code:', eCode);
            dispatch(getGoogleToken(authToken, eCode));
            navigate("/Setting/connect")
            setTimeout(() => {
                window.location.reload();
            }, 500);
            // You can now use the "code" in your React component's state or perform any desired actions.
        } else {
            console.log('No code parameter found in the URL');
        }
        // Cleanup: Set isMounted to false when the component unmounts
    }, []);
    
    const handleConnectCalendly = () => {
        dispatch(googleCalenderAuth(authToken,onSuccessAuth));
    }


  const handleUnlinkCalendly = async () => {
    await dispatch(unlinkCalenderApi(props.authToken));
    await dispatch(getGoogleCalenderApiDetail(props.authToken, onSuccess));
  };

  return (
    <>
      {isLoading && <Loading />}
      {/* Tabs */}
      <div className="px-6 sm:px-8 mb-0 lg:px-10">
        <TabCalender tabs={tabs} setTabName={setTabName} tabName={tabName} />
      </div>

      <div className="h-[78vh] overflow-y-auto listing pt-1">
        <div className="px-6 sm:px-8 lg:px-10">
          {calendarData?.length > 0 &&
            calendarData?.map((item, index) => {
              return (
                <>
                  <div className="px-0">
                    <img src={calendar} className="w-[200px]" alt="logo-cal" />
                    <p className="font-semibold text-gray-700 text-lg">
                      {item.status != "1"
                        ? "Connect your calendar"
                        : "Success!"}
                    </p>
                    <p className="w-[40%] max-sm:w-full mb-4">
                      {item.status != "1"
                        ? "To get started, link your Google account to Zoi. All the Zoi events and appointments will get added directly to your Google calendar."
                        : "Congratulations, you have successfully linked your Google calendar with Zoi."}
                    </p>
                    {item?.status == 1 && <p className="w-[40%] max-sm:w-full mb-4">
                      <span className="font-bold">Connected Email</span> - {item?.connected_email}
                    </p>}

                    <div className="flex justify-start h-[20vh]">
                      <>
                        {item.status != "1" ? (
                          <div
                            className="flex justify-center h-[28px] cursor-pointer bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] w-[200px] text-white rounded-md text-sm p-1"
                            onClick={handleConnectCalendly}
                          >
                            <span className="flex">
                              <Icon.Link45deg className="text-[20px] mr-2" />
                              Link Google Calendar
                            </span>
                          </div>
                        ) : (
                          <div className="text-left h-[28px] bg-transparent font-medium w-full text-black rounded-md text-sm p-0">
                            <div
                              className="flex justify-center h-[28px] mb-8 cursor-pointer bg-[#c0503f] hover:bg-[#c6796d] w-[260px] text-white rounded-md text-sm p-1"
                              onClick={handleUnlinkCalendly}
                            >
                              <span className="flex w-full justify-center font-normal">
                                <img
                                  src={Unlink}
                                  alt="Unlink"
                                  className="text-[20px] w-5 h-[18px] mr-2"
                                />{" "}
                                Disconnect Google Calendar
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default SettingCalender;
